import React from "react";
import {
  Box,
  Container,
  Typography,
  Link,
  useTheme,
  useMediaQuery,
} from "@mui/material";

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: "auto",
        backgroundColor: (theme) =>
          theme.palette.mode === "light"
            ? theme.palette.grey[200]
            : theme.palette.grey[800],
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            justifyContent: "space-between",
            alignItems: isMobile ? "center" : "flex-start",
          }}
        >
          <Box sx={{ mb: isMobile ? 2 : 0 }}>
            <Typography variant="body2" color="text.secondary">
              © {new Date().getFullYear()} Checklist App
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              alignItems: isMobile ? "center" : "flex-start",
            }}
          >
            <Link
              href="#"
              color="inherit"
              sx={{ mx: isMobile ? 0 : 1, my: isMobile ? 0.5 : 0 }}
            >
              Privacy Policy
            </Link>
            <Link
              href="#"
              color="inherit"
              sx={{ mx: isMobile ? 0 : 1, my: isMobile ? 0.5 : 0 }}
            >
              Terms of Service
            </Link>
            <Link
              href="#"
              color="inherit"
              sx={{ mx: isMobile ? 0 : 1, my: isMobile ? 0.5 : 0 }}
            >
              Contact Us
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
